<template>
  <b-modal :id="modalId" :ref="modalId" @show="reset" size="lg" :title="existingSponsor ? 'Edit Sponsor' : 'Add Sponsor'" no-close-on-backdrop>
    <form autocomplete="off" class="w-full mt-2 grid grid-cols-2 gap-6">
      <div>
        <div class="mb-2">
          <label class="block text-gray-700 font-bold" for="level">
            Sponsor Level
          </label>
        </div>
        <div class="relative">
          <select v-model="sponsor.level" @change="setAmount" class="appearance-none border border-gray-300 text-gray-700 rounded w-full py-2 px-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="sponsorLevel">
            <option :value="null" selected disabled>
              Select Level
            </option>
            <option v-for="l in levels" :key="l.name" :value="l.name">
              {{l.name}}
            </option>
          </select>
          <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
          </div>
        </div>
      </div>
      <div>
        <div v-if="needsModifier">
          <div class="mb-2">
            <label class="block text-gray-700 font-bold" for="sponsor.modifier">
              Modifier
            </label>
          </div>
          <div class="relative">
            <select v-model="sponsor.modifier" class="appearance-none border border-gray-300 text-gray-700 rounded w-full py-2 px-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="sponsor.modifier">
              <option :value="null" selected disabled>
                Select Modifier
              </option>
              <option v-for="m in levelObject.modifiers || []"  :key="m" :value="m">
                {{m}}
              </option>
            </select>
            <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
              <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="mb-2">
          <label class="block text-gray-700 font-bold" for="sponsor.sponsor_name">
            Sponsor Name
          </label>
        </div>
        <input type="text" v-model="sponsor.sponsor_name" class="text-input focus:outline-none focus:shadow-outline" />
      </div>
      <div>
        <div class="mb-2">
          <label class="block text-gray-700 font-bold" for="sponsor.contact_name">
            Contact Name
          </label>
        </div>
        <input type="text" v-model="sponsor.contact_name" class="text-input focus:outline-none focus:shadow-outline" />
      </div>
      <div class="col-span-2">
        <div class="mb-2">
          <label class="block text-gray-700 font-bold" for="sponsor.address">
            Address
          </label>
        </div>
        <input type="text" v-model="sponsor.address" class="text-input focus:outline-none focus:shadow-outline" />
      </div>
      <div>
        <div class="mb-2">
          <label class="block text-gray-700 font-bold" for="sponsor.city">
            City
          </label>
        </div>
        <input type="text" v-model="sponsor.city" class="text-input focus:outline-none focus:shadow-outline" />
      </div>
      <div>
        <div class="mb-2">
          <label class="block text-gray-700 font-bold" for="sponsor.state">
            State
          </label>
        </div>
        <!-- block appearance-none w-full bg-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500 -->
        <div class="relative">
          <select v-model="sponsor.state" class="appearance-none border border-gray-300 text-gray-700 rounded w-full py-2 px-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
            <option :value="null" selected disabled>
              Select a state
            </option>
            <option v-for="s in Localized.getStateList(sponsor.country)"  :key="s.name" :value="s.abbreviation">
              {{s.name}}
            </option>
          </select>
          <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
          </div>
        </div>
      </div>
      <div>
        <div class="mb-2">
          <label class="block text-gray-700 font-bold" for="sponsor.zip">
            Zip Code
          </label>
        </div>
        <input type="text" v-model="sponsor.zip" class="text-input focus:outline-none focus:shadow-outline" />
      </div>
      <div>
        <div class="mb-2">
          <label class="block text-gray-700 font-bold" for="sponsor.state">
            Country
          </label>
        </div>
        <!-- block appearance-none w-full bg-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500 -->
        <div class="relative">
          <select v-model="sponsor.country" class="appearance-none border border-gray-300 text-gray-700 rounded w-full py-2 px-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
            <option :value="null" selected disabled>
              Select a country
            </option>
            <option v-for="s in Localized.countryList"  :key="s.name" :value="s.abbreviation">
              {{s.name}}
            </option>
          </select>
          <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
          </div>
        </div>
      </div>
      <div class="mb-2">
        <div class="mb-2">
          <label class="block text-gray-700 font-bold" for="sponsor.email">
            Email
          </label>
        </div>
        <input type="text" v-model="sponsor.email" class="text-input focus:outline-none focus:shadow-outline" />
      </div>
      <div class="mb-2">
        <div class="mb-2">
          <label class="block text-gray-700 font-bold" for="sponsor.phone_number">
            Phone Number
          </label>
        </div>
        <input type="text" v-model="sponsor.phone_number" class="text-input focus:outline-none focus:shadow-outline" />
      </div>
      <div class="mb-2">
        <div class="mb-2">
          <label class="block text-gray-700 font-bold" for="sponsor.website">
            Website
          </label>
        </div>
        <input type="text" v-model="sponsor.website" class="text-input focus:outline-none focus:shadow-outline" />
      </div>
      <div class="mb-2">
        <div class="mb-2">
          <label class="block text-gray-700 font-bold" for="sponsor.amount">
            Sponsorship Amount
          </label>
        </div>
        <input type="number" v-model="sponsor.amount" class="text-input focus:outline-none focus:shadow-outline" />
      </div>
      <div class="mb-2">
        <div class="mb-2">
          <label class="block text-gray-700 font-bold" for="sponsor.website">
            Hide Sponsor
          </label>
        </div>
        <div class="flex items-center gap-2">
          <input type="checkbox" id="hidden-check" v-model="sponsor.hidden"  />
          <label for="hidden-check" class="text-gray-600 text-sm">Don't display in Show Sponsors section</label>
        </div>
      </div>
      <div class="col-span-2 mb-2">
        <div class="mb-2">
          <label class="block text-gray-700 font-bold" for="sponsor.comments">
            Comments
          </label>
        </div>
        <textarea v-model="sponsor.comments" rows="4" class="text-input" />
      </div>
    </form>
      <div slot="modal-footer" class="w-100">
        <button class="btn btn-gray-outline mr-3" variant="primary" @click="$refs[modalId].hide()">
            Cancel
        </button>
        <button v-if="existingSponsor" class="btn btn-green" @click="saveSponsor">Save Sponsor</button>
        <button v-else class="btn btn-green" @click="addSponsor">Add Sponsor</button>
      </div>
  </b-modal>
</template>

<script>
import {SPONSOR_NUMBER_TYPES} from './utils'

export default {
  props: {
    existingSponsor: {
      type: Object,
      default: null
    },
    levels: {
      type: Array,
      default: () => []
    },
    modalId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      sponsor: {
        contact_name: '',
        sponsor_name: '',
        country: 'US',
        address: '',
        city: '',
        state: '',
        email: '',
        website: '',
        comments: '',
        modifier: null,
        phone_number: null,
        level: null,
        hidden: false
      }
    }
  },
  watch: {
    existingSponsor: function (s) {
      if (s) {
        this.sponsor = {...s}
      }
    }
  },
  computed: {
    event () {
      return this.$store.state.admin.adminData.event
    },
    isFormInvalid () {
      return !this.sponsor.sponsor_name || !this.levelObject || (this.needsModifier && !this.sponsor.modifier)
    },
    levelObject () {
      return this.levels.find(l => l.name === this.sponsor.level)
    },
    needsModifier () {
      return this.levelObject && this.levelObject.modifiersEnabled
    },
    SPONSOR_NUMBER_TYPES () {
      return SPONSOR_NUMBER_TYPES
    }
  },
  methods: {
    addSponsor () {
      if (this.isFormInvalid) {
        return this.alertIfInvalid()
      }
      const modifiedSponsor = {...this.sponsor, website: this.formatWebsite(this.sponsor.website)}
      this.$emit('added-sponsor', {sponsor: modifiedSponsor})
      this.$refs[this.modalId].hide()
    },
    alertIfInvalid () {
      const alertMessage = this.needsModifier ? `Sponsor name, level, and modifier are required` : `Sponsor name and level are required.`
      return alert(alertMessage)
    },
    formatPhoneNumber (phoneNumber) {
      if (phoneNumber) {
        const digits = phoneNumber.replace(/\D/g, '')
        if (digits) {
          return parseInt(digits)
        }
      }
      return null
    },
    formatWebsite (website) {
      if (website) {
        let webRe = /^https?:\/\/(.*)/i
        var hasHttp = website.match(webRe)
        if (hasHttp) {
          return website
        } else {
          return 'https://' + website
        }
      }
      return ''
    },
    saveSponsor () {
      if (this.isFormInvalid) {
        return this.alertIfInvalid()
      }
      const modifiedSponsor = {...this.sponsor, website: this.formatWebsite(this.sponsor.website), phone_number: this.formatPhoneNumber(this.sponsor.phone_number)}
      this.$emit('edited-sponsor', {oldSponsor: this.existingSponsor, newSponsor: modifiedSponsor})
      this.$refs[this.modalId].hide()
    },
    reset () {
      if (!this.existingSponsor) {
        Object.assign(this.$data, this.$options.data.call(this))
      }
    },
    setAmount (l) {
      if (this.levelObject.amountFixed) {
        this.sponsor.amount = this.levelObject.amountFixed
      }
    }
  }
}
</script>
